/**
 * Gestión del error
 *
 * @link https://www.mendikat.net
 * @author Javi Urrutia <javi@mendikat.net>
 * @copyright 2003-2025 Mendikat
 * @license Mendikat
 * @version {see config/app.php}
 */

new Vue({
    el: '#app',
    data: {

        // El idioma de la página
        lang : 'es',
    },
    /**
     * Si la instancia se ha montado
     *
     */
    mounted: function () {
        this.lang = lang.value;
    },
    methods: {
        /**
         * Volver a la página anterior
         *
         */
        goBack: function () {
            history.go(-1);
        },
       /**
         * Ir a la landing page
         *
         */
        goHome: function () {
            location.href = `/${this.lang}`;
        },

    }
});
